// Main JavaScript

// ============================================================================
// IIFE Wrapper - verhindert "duplicate variable" Fehler
// ============================================================================

(function() {
    'use strict';

    /**
     * Initialize all main functionality when DOM is ready
     */
    function init(): void {
        // Initialize i18n
        if (window.I18n) {
            window.I18n.init();
        }

        // Language switcher
        setupLanguageSwitcher();

        // Mobile menu
        setupMobileMenu();

        // Smooth scroll
        setupSmoothScroll();

        // Contact form
        setupContactForm();

        // Scroll effects
        setupScrollEffects();
    }

    /**
     * Setup language switcher buttons
     */
    function setupLanguageSwitcher(): void {
        const buttons = document.querySelectorAll('.cp-language-switcher__button');

        buttons.forEach(function(btn) {
            btn.addEventListener('click', function(this: HTMLElement) {
                const lang = this.getAttribute('data-lang');

                if (lang && window.I18n && lang !== window.I18n.currentLang) {
                    window.I18n.apply(lang as 'de' | 'en');
                }
            });
        });
    }

    /**
     * Setup mobile menu toggle
     */
    function setupMobileMenu(): void {
        const toggle = document.getElementById('mobileMenuToggle');
        const navLinks = document.querySelector('.cp-navbar__links');

        if (!toggle || !navLinks) return;

        toggle.addEventListener('click', function() {
            navLinks.classList.toggle('cp-navbar__links--open');
            toggle.classList.toggle('cp-navbar__mobile-toggle--active');
        });

        navLinks.querySelectorAll('a').forEach(function(link) {
            link.addEventListener('click', function() {
                navLinks.classList.remove('cp-navbar__links--open');
                toggle.classList.remove('cp-navbar__mobile-toggle--active');
            });
        });
    }

    /**
     * Setup smooth scroll for anchor links
     */
    function setupSmoothScroll(): void {
        document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
            anchor.addEventListener('click', function(e: Event) {
                e.preventDefault();
                const targetAnchor = e.currentTarget as HTMLAnchorElement;
                const href = targetAnchor.getAttribute('href');
                if (!href) return;

                const target = document.querySelector(href);

                if (target) {
                    const offset = 80;
                    const element = target as HTMLElement;
                    const position = element.offsetTop - offset;

                    window.scrollTo({
                        top: position,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    /**
     * Setup contact form handling
     */
    function setupContactForm(): void {
        const form = document.getElementById('contactForm') as HTMLFormElement | null;
        const success = document.getElementById('formSuccess');

        if (!form || !success) return;

        form.addEventListener('submit', function(e: Event) {
            e.preventDefault();

            form.style.display = 'none';
            success.style.display = 'block';

            setTimeout(function() {
                form.reset();
                form.style.display = 'flex';
                success.style.display = 'none';
            }, 5000);
        });
    }

    /**
     * Setup scroll effects for navbar
     */
    function setupScrollEffects(): void {
        const navbar = document.querySelector('.cp-navbar');

        if (navbar) {
            window.addEventListener('scroll', function() {
                if (window.pageYOffset > 100) {
                    (navbar as HTMLElement).style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                } else {
                    (navbar as HTMLElement).style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                }
            });
        }
    }

    // Run init when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Listen for cookie consent changes
    document.addEventListener('cookieConsentChanged', function(e: Event) {
        const customEvent = e as CustomEvent<{ analytics: boolean }>;
        // Re-initialize features that depend on cookie consent
        if (customEvent.detail && customEvent.detail.analytics) {
            // Analytics features can be enabled here
            console.log('Analytics consent granted');
        }
    });

})();
